import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateCancelOrderReasonEntity } from '../../domain/entities/CreateUpdateCancelOrderReasonEntity'
import { RoleType, type PostPutCancelOrderReasonRequestAdmin } from '@/backend/market'

export class CreateUpdateCancelOrderReasonModel extends CreateUpdateCancelOrderReasonEntity {
  role = RoleType.CLIENT
  translations = []
  constructor(dataDto: CreateUpdateCancelOrderReasonEntity) {
    super()
    mapEntityProperties<PostPutCancelOrderReasonRequestAdmin>(this, dataDto)
  }
}
